// extracted by mini-css-extract-plugin
export default {"footer":"H_bT","row":"H_c2","menuColumn":"H_c3","trademarks":"H_c4"};